import { CellSelection } from 'common/Prose/utils/table/CellSelection'
import { ReactNodeView, TCreateReactNodeView } from '../ReactNodeView/ReactNodeView'

export class TableNodeView extends ReactNodeView {
  ignoreMutation = () => true
  selectNode = () => {
    this.rerender()
  }
  deselectNode = () => {
    this.rerender()
  }
  setSelection: ((anchor: number, head: number, root: Document) => void) | null = (anchor, head, root) => {
    if (!(this.view.state.selection instanceof CellSelection)) {
      // If the user is trying to select something inside the table (i.e. a piece of text), we want
      // to fall back to the default behavior (just draw a normal browser selection). However,
      // because we have defined a setSelection method, prosemirror defers handling to this function
      // Therefore we "undefine" this function and force prosemirror to process the selection again,
      // and after that is done we restore the function
      const storeSetSelection = this.setSelection
      this.setSelection = null
      // we receive `anchor` and `head` as numbers relative to this node, but we have to pass
      // absolute values to docView.setSelection, so we correct the numbers.
      // view.docView is not exposed in the TS definition, but it will be there at runtime
      ;((this.view as any).docView as any).setSelection(anchor + this.getPos() + 1, head + this.getPos() + 1, root)
      this.setSelection = storeSetSelection
    }
    this.rerender()
  }

  stopEvent: ((event: Event) => boolean) | null = (e) => {
    // In web mobile mouse events and keyboard events are complicated
    if (e instanceof MouseEvent && (e.target as HTMLElement).closest?.('.TableHandlesContainer')) {
      return true
    }
    if (e instanceof MouseEvent && e.shiftKey === true && this.contentDOM?.contains(e.target as HTMLElement)) {
      this.rerender()
    }
    return false
  }

  destroy() {
    // unbind these functions so that they do not try to update the unmounted nodeView
    //@ts-ignore
    delete this.deselectNode
    //@ts-ignore
    delete this.setSelection
    super.destroy()
  }
}

export const createTableNodeView = ({
  node,
  view,
  getPos,
  decorations,
  component,
  onCreatePortal,
  onDestroyPortal,
  inCommentMode,
}: TCreateReactNodeView) => {
  const reactNodeView = new TableNodeView(node, view, getPos, decorations, component, onDestroyPortal, !!inCommentMode)
  const { nodeView, portal } = reactNodeView.init()
  onCreatePortal(portal)

  return nodeView
}
